import React, { useState, useEffect, useMemo } from "react";
import Link from "../../Link";
import MyGraph from "./MyGraph";
import moment from "moment";
import styled, { css } from "styled-components";
import { Graph, GraphsContainer, GraphContainer } from "./Theme";

const distinct = (value, index, self) => {
  return self.indexOf(value) === index;
};

export default function GraphCollection({
  charts,
  clearCharts,
  findSamples,
  removeChart,
  simpleView = false
}) {
  const [combineAll, setCombineAll] = useState(false);

  const combinedChart = useMemo(
    () => {
      if (charts.length == 0) return {};
      var product_ids = [];
      var test_name_ids = [];
      charts.map(chart => {
        product_ids = product_ids.concat(chart.product_ids);
        test_name_ids = test_name_ids.concat(chart.test_name_ids);
      });
      return {
        label: "Combined Chart",
        full_description: "Combined Chart",
        start_date: charts[0].start_date,
        end_date: charts[0].end_date,
        product_ids: product_ids.filter(distinct),
        test_name_ids: test_name_ids.filter(distinct)
      };
    },
    [charts]
  );

  if (charts.length == 0) {
    return <div />;
  }

  return (
    <GraphsContainer>
      {!simpleView && (
        <div style={{ textAlign: "center", paddingBottom: 10 }}>
          <label>
            <input
              type="checkbox"
              checked={combineAll}
              onChange={() => setCombineAll(!combineAll)}
            />
            &nbsp; Combine all selected charts?
          </label>
        </div>
      )}
      {combineAll ? (
        <Graph>
          <MyGraph
            key={combinedChart.full_description}
            chart={combinedChart}
            findSamples={findSamples}
          />
        </Graph>
      ) : (
        charts.map(c => (
          <Graph key={c.full_description}>
            <MyGraph chart={c} findSamples={findSamples} removeChart={removeChart} />
          </Graph>
        ))
      )}
    </GraphsContainer>
    // </div>
  );
}
